export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-04.9e3124a7.svg";